import { useOverlayStore } from "@/hooks/use-overlay-store"

const DropdownTrigger = ({ label, placeholder, onClick, targetId }) => {
  const { activeId } = useOverlayStore()

  return (
    <button
      type="button"
      onClick={onClick}
      className="
        min-w-full
        md:min-w-40 flex items-center justify-between
        rounded-lg border border-gray-300 bg-white
        px-4 py-1.5 text-sm font-medium shadow-sm
        hover:bg-gray-50 transition-colors cursor-pointer
      "
    >
      <span className="truncate">{label ? label : placeholder}</span>
      <span
        className={`transition-transform duration-200 ${activeId === targetId ? "rotate-180" : ""}`}
      >
        ▾
      </span>
    </button>
  )
}

export default DropdownTrigger
